import React from 'react'
import LandingSection from './LandingSection'

const Academics = () => {
  return (
    <LandingSection/>
    
  )
}

export default Academics